import type { FC } from 'react'
import { Toaster } from 'react-hot-toast'
import { Route, Routes } from 'react-router-dom'
import './App.css'
import { ContentContainer } from './components/ContentContainer/ContentContainer'
import Footer from './components/Footer/Footer'
import NavBar from './components/NavBar/NavBar'
import { ProtectedRoute } from './components/ProtectedRoute'
import ChargingSteeringPage from './pages/ChargingSteeringPage/ChargingSteeringPage'
import Feature2ChargingSteeringPage from './pages/Feature2ChargingSteeringPage/Feature2ChargingSteeringPage'
import LoginErrorPage from './pages/LoginErrorPage'
import LoginPage from './pages/LoginPage'
import OAuthRedirectPage from './pages/OAuthRedirectPage'
import VehicleSelectionPage from './pages/VehicleSelectionPage/VehicleSelectionPage'

const App: FC = () => {
  const environment = getEnvironment()

  return (
    <div className="app-component">
      <NavBar />
      <Toaster />
      <ContentContainer>
        <div className="app-header">
          <h2 className="service-name">F3 TESTING CLIENT {environment}</h2>
          <p className="service-description">
            F3 Testing Client is a secure test interface for managing B2BC consents and validating
            vehicle charging steering workflows end-to-end
          </p>
        </div>

        <div className="main-content">
          <Routes>
            <Route path="/" element={<LoginPage />} />
            <Route path="/oauth/callback" element={<OAuthRedirectPage />} />
            <Route path="/error" element={<LoginErrorPage />} />
            <Route
              path="/vehicles"
              element={<ProtectedRoute element={<VehicleSelectionPage />} />}
            />
            <Route
              path="/charging-steering"
              element={<ProtectedRoute element={<ChargingSteeringPage />} />}
            />
            <Route
              path="/feature2-charging-steering"
              element={<ProtectedRoute element={<Feature2ChargingSteeringPage />} />}
            />
          </Routes>
        </div>
      </ContentContainer>
      <Footer />
    </div>
  )
}

export default App

const getEnvironment = () => {
  const hostname = window.location.hostname

  if (hostname.startsWith('int.') || hostname.startsWith('localhost')) return '(INT)'
  if (hostname.startsWith('e2e.')) return '(E2E)'

  return ''
}
